import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './company_create.route';

import CompanyService from '../../../components/api/company/company.service';

export class CompanyCreateController {
    /*@ngInject*/
    constructor($state, $mdDialog, CompanyService) {
        this.CompanyService = CompanyService;
        this.$mdDialog      = $mdDialog;
        this.$state         = $state;

        // 初期値
        this.companyName = '';
        this.createInitialEndUser = false;
        this.initialUserData = {
            'name': '',
            'email': '',
            'email_match': '',
        };
    }

    $onInit() {}

    addCompany() {
        let dialog = {
            confirm: this.$mdDialog.confirm({
                clickOutsideToClose:true,
                title: `${this.companyName} を追加しますか？` ,
                ok: '追加する',
                cancel: '戻る'
            }),
            success: this.$mdDialog.alert({
                clickOutsideToClose:true,
                title: '追加しました',
                content: '設定変更画面に移動します。サポート用アカウントを確認してください。',
                ok: 'OK'
            }),
            duplication_error: this.$mdDialog.alert({
                clickOutsideToClose: true,
                title: 'アカウントの作成に失敗しました',
                content: '初期アカウントとして入力されたメールアドレスは既に登録されています。',
                ok: 'OK'
            }),
            error: this.$mdDialog.alert({
                clickOutsideToClose:true,
                title: 'エラーが発生しました',
                content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
                ok: 'OK'
            })
        };

        this.$mdDialog.show(dialog.confirm)
            .then(() => {
                this.submitted = true;

                // リクエストの Content-Body の中身
                let payload = {
                    // 顧客名は必須
                    name: this.companyName
                }

                // 「初期アカウントを追加する」にチェックが入っているとき
                if (this.createInitialEndUser) {
                    // Content-Body にユーザ名とメールアドレスを追加する
                    payload['initial_username'] = this.initialUserData['name'];
                    payload['initial_useremail'] = this.initialUserData['email'];
                }

                this.CompanyService.create(
                    payload,
                    successResponse => {
                        this.$mdDialog.show(dialog.success).finally(() => {
                            this.$state.go('oem_main.company_edit', { company_id: successResponse.id });
                        });
                    },
                    errorResponse => {
                        this.submitted = false;
                        if (errorResponse.data.message.email && errorResponse.data.message.email[0] === 'address is already in use') {
                            this.$mdDialog.show(dialog.duplication_error);
                        } else {
                            this.$mdDialog.show(dialog.error);
                        }
                    }
                );
            });
    }
}

export default angular.module('leptonApp.companyCreate', [uiRouter, CompanyService])
    .config(routing)
    .component('companyCreate', {
        template: require('./company_create.html'),
        controller: CompanyCreateController
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/company/create/company_create.component.js